import type {
  Icon as PhosphorIcon,
  IconProps as PhosphorIconProps,
  IconWeight,
} from '@phosphor-icons/react'
import { cn } from '@/lib/cn'
import styles from './Icon.module.css'

const iconSizes = {
  sm: 16,
  md: 22,
  lg: 24,
  xl: 32,
} as const

type IconSize = keyof typeof iconSizes

type IconProps = {
  as: PhosphorIcon
  size?: IconSize | number
  weight?: IconWeight
} & Omit<PhosphorIconProps, 'size' | 'weight'>

function resolveIconSize(size: IconSize | number): number {
  return typeof size === 'number' ? size : iconSizes[size]
}

export function Icon({
  as: PhosphorIconComponent,
  size = 'md',
  weight = 'regular',
  className,
  'aria-hidden': ariaHidden = true,
  ...props
}: IconProps) {
  return (
    <PhosphorIconComponent
      size={resolveIconSize(size)}
      weight={weight}
      aria-hidden={ariaHidden}
      className={cn(styles.icon, className)}
      {...props}
    />
  )
}
